import gql from "graphql-tag";
export const ContactSearch = `query($where: JSON){
  allCampaigns(where: $where){
    Campaigns{
      customerIbfk1rel{
        Customers{
          company
          id
        }
      }
    }
  }
}`;

export const CampaignSearch = `query ($where: JSON){
  allCustomers(where: $where){
    Customers{
      id
    company
    campaignfk{
      Campaigns{
        id
        name
       Manager: usersIbfk1rel{
           Usersdata{
           id
            firstName
            lastName
          }
        }
      }
    }
    }
  }
}`;
export const CampaignData = `query ($where: JSON){
       allUsersdata(where: $where){
           Usersdata{
            id
            firstName
            lastName
          }
        }
}`;

export const Company = gql`
  query($where: JSON ) {
    allCustomers(where: $where) {
      Customers {
        id
        company
      }
    }
  }
`;

